import client from "./client";

export async function getProductOptions(inputs: Record<string, unknown>) {
    const response = await client.post("/product-options", inputs);

    return response.data;
}

export async function loadProductPages(slug: string) {
    const response = await client.get(`/products/${slug}/product-pages/load`);

    return response.data;
}

export async function loadProductCategories() {
    const response = await client.get("/product-categories/load");

    return response.data;
}
